import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '@app/core/config/config.service';
import { AuthService } from '@app/core/guards/auth.service';
import { HttpService } from '@app/core/http/http.service';
import * as _ from 'lodash';
import { PagedSupplierModel } from "../models/supplier/PagedSupplierModel";
import { SearchCriteria } from '../models/supplier/SearchCriteria';

@Injectable({
    providedIn: 'root'
})
export class SupplierService extends HttpService {

    constructor(protected http: HttpClient, protected config: ConfigService, protected authService: AuthService) {
        super(http, config, authService, 'suppliers');
    }

    search(searchCriteria: SearchCriteria): Observable<PagedSupplierModel> {
        return this.invokeGet<PagedSupplierModel>(null, searchCriteria);
    }

    getSupplierEmail(supplierId: number): Observable<any> {
        return this.invokeGet<any>(`${supplierId}/contact`);
    }
}